import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PostWorkPlace(workPlace, modifiedBy) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}workplace`;

    const workPlacePost = {
        name: workPlace.name,
        company: workPlace.company,
        responsible: workPlace.responsibleId,
        modifiedBy: modifiedBy,
    };

    const response = await axios.post(req, workPlacePost, apiConfig.HEADERS_CONFIG, {
    });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
